import { render, staticRenderFns } from "./PhoneAlert.vue?vue&type=template&id=ab34a9b2"
import script from "./PhoneAlert.vue?vue&type=script&lang=js"
export * from "./PhoneAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports